import DeviceAccessGroupsModal from './DeviceAccessGroupsModal';

export default DeviceAccessGroupsModal;
